/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PersonName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function PersonName({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/AddPersonRelation/Content/CopyRelationships/Content/Relationships/Content/CopyRelationshipItem/PersonName"
  
}) {
let relationshipFromPersonRecordValueData = fromData.useDataFormat({ viewPath,
context: 'relationship',
path: 'from_person_record',
format: fromFormat.patientName,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="relationship.from_person_record"
 format="/Data/format.js patientName"
 text={relationshipFromPersonRecordValueData}
/>
{children}
</React.Fragment>)
}